import styled from '@emotion/styled';

import { globalVariables } from '../../shared/designSystem/constants';
import FooterBottomBox from '../components/FooterBottomBox';
import FooterTopBox from '../components/FooterTopBox';
import { useDetermineMobile } from '@myrealtrip/device-detect';

export default function Footer() {
  const isMobile = useDetermineMobile();

  const Inner = isMobile ? MobileInner : DesktopInner;

  return (
    <Container id="mrt-footer">
      <Inner>
        <FooterTopBox />
        <FooterBottomBox />
      </Inner>
    </Container>
  );
}

const Container = styled.footer`
  position: relative;
  padding-bottom: calc(constant(safe-area-inset-bottom));
  padding-bottom: calc(env(safe-area-inset-bottom));
  background-color: ${globalVariables.white};
  border-top: 1px solid ${globalVariables.gray_100};
`;

const CommonInner = styled.div`
  max-width: 1060px;
  margin: 0 auto;
`;

const MobileInner = styled(CommonInner)`
  padding: 32px 16px;
`;

const DesktopInner = styled(CommonInner)`
  padding: 40px 0;
`;
